{
  "bookmarksMenu": "मेनू",
  "change": "बदलें",
  "closeBookmarksMenu": "मेनू बंद करें",
  "closeDialog": "बंद करें",
  "colonoscopy": "कोलोनोस्कोपी (colonoscopy)",
  "continue": "जारी रखें",
  "details": "विवरण",
  "errors": {
    "invalidOtp": {
      "details": "<ul>  \n<li>कृपया कोई वर्तनी की गलती हो तो जांचें और फिर से प्रयास करें।</li>  \n<li>अगर आप अटक गए हैं, तो कृपया हमें {{phone}} पर कॉल करें (फिर Option 2 दबाएँ)।</li>  \n</ul>",
      "title": "यह हमारी रिकॉर्ड्स से मेल नहीं खाता"
    },
    "serverErrorOtp": {
      "details": "<ul>  \n<li>आपकी जानकारी सही हो सकती है – लेकिन हम अभी उन्हें सत्यापित नहीं कर पाए।</li>  \n<li>कृपया एक क्षण प्रतीक्षा करें और फिर से प्रयास करें।</li>  \n</ul>",
      "title": "कुछ गलत हो गया।"
    }
  },
  "formattedDate": "{{date}} को {{time}} बजे",
  "gastroscopy": "गैस्ट्रोस्कोपी (gastroscopy)",
  "loading": "लोड हो रहा है...",
  "next": "आगे",
  "no": "नहीं",
  "openBookmarksMenu": "मेनू खोलें",
  "optional": "वैकल्पिक",
  "progress": "प्रगति {{progress}}%",
  "selectLanguage": "भाषा चुनें",
  "step": {
    "appointment": "अपॉइंटमेंट का समय",
    "details": "व्यक्तिगत विवरण",
    "health-questions": "स्वास्थ्य संबंधी प्रश्न",
    "history": "पूर्व प्रक्रियाएं या सर्जरी",
    "insurance": "स्वास्थ्य बीमा",
    "medications": "दवाइयां",
    "preference-questions": "पसंद से संबंधित प्रश्न",
    "specialist": "विशेषज्ञ"
  },
  "videoUnsupported": "आपका ब्राउज़र वीडियो टैग का समर्थन नहीं करता है।",
  "yes": "हाँ",
  "yesTo": "हाँ, इसके लिए",
  "yourProgress": "आपकी प्रगति"
}
